import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InteractionsService } from 'src/app/services/interactions.service';
import { CommonsService } from 'src/app/services/common.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-interaction-custom',
  templateUrl: './interaction-custom.component.html',
  styleUrls: ['./interaction-custom.component.scss']
})
export class InteractionCustomComponent implements OnInit {

  private interactionSubscriber = this.interactionService.interactions$;
  public interactions;
  public interaction;

  constructor(
    private activatedRoute: ActivatedRoute,
    private interactionService: InteractionsService,
    private common: CommonsService,
    private router: Router,
    public deviceDetector: DeviceDetectorService
  ) {
    this.common.setHeader('interaction');
  }

  ngOnInit(): void {
    const interactionType = this.activatedRoute.snapshot.params.type;
    const interactionSlug = this.activatedRoute.snapshot.params.slug;

    this.interactionSubscriber.subscribe(interactions => {
      if (!interactions) { // the main page was not been initializated
        // init the interactions Subject
        this.interactionService.getInteractions();
      } else {
        this.interactions = interactions;
        this.interaction = interactions.filter(int => int.url === interactionSlug)[0];
      }
    });

  }
}
